import React, {
    useEffect, useState,
} from 'react';
import _ from 'lodash';
import format from 'date-fns/format';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import ReactPlayer from '../../components/ReactPlayer/ReactPlayer';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';
import CustomTypography from '../../components/Typography/CustomTypography';
import DetailSeminarStyle from '../../assets/jss/pages/detailSeminarCompanyStyle';
import Button from '../../components/Button/CustomButton';
import FormDialog from '../../components/Dialog/FormDialog';
import CustomTextSelector from '../../selectors/CustomText';

const useStyles = makeStyles(DetailSeminarStyle);

const titleDialog = (title) => (
    <Box>
        <CustomTypography variant="h6" bold color="info">
            {title || 'セミナー詳細'}
        </CustomTypography>
    </Box>
);
export default function DetailSeminar(props) {
    const {
        isOpen, handleClose, datailSeminar, handleEditInDetail, token, eventInfo,
    } = props;
    const classes = useStyles();
    const [params, setParams] = useState({});
    const intl = useIntl();
    const customText = useSelector(CustomTextSelector.createGetCustomText());

    useEffect(() => {
        setParams(datailSeminar);
    }, [datailSeminar]);

    const getLastTextUrl = (url) => {
        if (url) {
            const arr = url.split('/');
            return arr[arr.length - 1];
        }
        return '';
    };

    const actionsButton = () => (
        <Box style={{ margin: 'auto' }}>
            <Button
                autoFocus
                gradient
                onClick={() => handleEditInDetail(params.id)}
                size="md"
                color="success"
                className={classes.btn}
                style={{ width: '200px', fontSize: '20px', left: ' 20%' }}
            >
                編集する
            </Button>
            <Button
                autoFocus
                gradient
                onClick={handleClose}
                size="md"
                color="danger"
                style={{ width: '150px', marginRight: '10px', left: ' 80%' }}
            >
                {intl.formatMessage({ id: 'cancel' })}
            </Button>
        </Box>
    );

    return (
        <>
            <FormDialog
                isOpen={isOpen}
                handleClose={handleClose}
                title={titleDialog(customText?.content?.screen_name?.seminar_details)}
                actions={actionsButton()}
            >
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.conference_room || '会議室'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography bold>
                            {params.room}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.dates || '開催日'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography bold>
                            {params.date && format(new Date(params.date), 'yyyy/MM/dd')}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.open_time || '開催時間'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography bold>
                            {params.stime}
                            {' '}
                            ~
                            {' '}
                            {params.etime}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {!_.isEmpty(eventInfo.languages)
                                ? `${customText?.content?.field_name?.lecture_name || '講演名'}（和文）`
                                : (customText?.content?.field_name?.lecture_name || '講演名')}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography>
                            {params.title}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                {!_.isEmpty(eventInfo.languages) && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={3} md={3}>
                            <CustomTypography bold>
                                {`${customText?.content?.field_name?.lecture_name || '講演名'}（英文）`}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={9} md={9}>
                            <CustomTypography>
                                {params.title_en}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                )}
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {!_.isEmpty(eventInfo.languages)
                                ? `${customText?.content?.field_name?.speaker || '講演者'}（和文）`
                                : (customText?.content?.field_name?.speaker || '講演者')}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography>
                            {params.speaker}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                {!_.isEmpty(eventInfo.languages) && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={3} md={3}>
                            <CustomTypography bold>
                                {`${customText?.content?.field_name?.speaker || '講演者'}（英文）`}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={9} md={9}>
                            <CustomTypography>
                                {params.speaker_en}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                )}
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.speaker_photo || '講演者写真'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <img src={params.speaker_img && params.speaker_img.concat('?=', new Date().getTime().toString())} alt="" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.speaker_profile || '講演者プロフィール'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography>
                            {params.speaker_profile}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {!_.isEmpty(eventInfo.languages)
                                ? `${customText?.content?.field_name?.lecture_content || '講演内容'}（和文）`
                                : (customText?.content?.field_name?.lecture_content || '講演内容')}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography>
                            {params.content}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                {!_.isEmpty(eventInfo.languages) && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={3} md={3}>
                            <CustomTypography bold>
                                {`${customText?.content?.field_name?.lecture_content || '講演内容'}（英文）`}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={9} md={9}>
                            <CustomTypography>
                                {params.content_en}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                )}
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.maximum_number_applicants || '申込最大人数'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={3} md={3}>
                        {/* {FREE_LOGIN.FREE_ALL.CODE !== eventInfo.free_login */}
                        {!eventInfo.free_seminar && eventInfo.has_shopping_cart
                            ? (
                                <CustomTypography>
                                    {params.limit}
                                    {' '}
                                    人
                                </CustomTypography>
                            )
                            : (
                                <CustomTypography>
                                    {intl.formatMessage({ id: 'noLimit' })}
                                </CustomTypography>
                            )}
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.audio_video_registration || '音声・動画登録'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        { params.media_type && (
                            <ReactPlayer
                                url={params.media && `${params.media}?token=${token}`}
                                mediaType={params.media_type}
                                status={params.media_status}
                            />
                        )}
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.lecture_materials || '講演資料'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography>
                            <a href={params.document}>
                                {getLastTextUrl(params.document)}
                            </a>
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.document_request_reception || '資料請求受付'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography>
                            {params.document_link}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.questionnaire || 'アンケート'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography>
                            {params.survey_link}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.price || '料金'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        {!eventInfo.free_seminar && eventInfo.has_shopping_cart
                            ? (
                                <CustomTypography>
                                    {intl.formatNumber(params.cost)}
                                    {' '}
                                    円
                                </CustomTypography>
                            )
                            : (
                                <CustomTypography>
                                    {intl.formatMessage({ id: 'free' })}
                                </CustomTypography>
                            )}
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold>
                            {customText?.content?.field_name?.inquiries || 'お問合せ'}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography>
                            {params.link_contact}
                        </CustomTypography>
                    </GridItem>

                </GridContainer>
            </FormDialog>
        </>
    );
}

DetailSeminar.defaultProps = {
    isOpen: false,
    datailSeminar: {},
    token: '',
    eventInfo: {},
};

DetailSeminar.propTypes = {
    isOpen: PropTypes.bool,
    handleClose: PropTypes.func.isRequired,
    handleEditInDetail: PropTypes.func.isRequired,
    datailSeminar: PropTypes.oneOfType([() => null, PropTypes.array]),
    token: PropTypes.string,
    eventInfo: PropTypes.PropTypes.oneOfType([() => null, PropTypes.object]),
};
